import { Component } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { ListaFuncionalidadeComponent } from '../../../shared/components/lista-funcionalidade/lista-funcionalidade.component';

@Component({
  selector: 'app-tintas-home',
  imports: [MenuComponent, ListaFuncionalidadeComponent],
  templateUrl: './tintas-home.component.html',
  styleUrl: './tintas-home.component.css',
})
export class TintasHomeComponent {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor() {
    this.moduloEnum = ModuloEnum.Tintas;
  }
}
